/**
 * @description The status of the order from the API, in transit, paid, canceled, etc.
 */
export enum OrderStatusEntityType {
  InProcess = 'InProcess',
  InReview = 'InReview',
  Canceled = 'Canceled',
  ToCancel = 'ToCancel',
  ReadyForPickup = 'ReadyForPickup',
  DepositInTransit = 'DepositInTransit',
  Deposited = 'Deposited',
  DeliveryInTransit = 'DeliveryInTransit',
  Delivered = 'Delivered',
  Paid = 'Paid',
  Verify = 'Verify',
  Resend = 'Resend',
  Unfunded = 'Unfunded',
  ConfirmationExpired = 'ConfirmationExpired',
  
  PAYMENT_PENDING_NUM_CODE = 10,
  PROCESSING_NUM_CODE = 20,
  BENEFICIARY_CAN_COLLECT_NUM_CODE = 30,
  COLLECTED_BY_BENEFICIARY_NUM_CODE = 40,
  CANCELLED_NUM_CODE = 50
}



// WEBPACK FOOTER //
// ./src/model/types/order-status-entity-type.ts